import { serverHttp } from "@/plugins/axios";

export const getOrgConfig = async function() {
    return serverHttp.get("/api/config/org");
};

export const getOnlinePaymentConfig = async function() {
    return serverHttp.get("/api/config/online-payment");
};

export const getCdutcmPortalConfig = async function() {
    return serverHttp.get("/api/config/cdutcm-portal");
};
